import { render } from "./EditStudentDataView.vue?vue&type=template&id=1d5b858a"
import script from "./EditStudentDataView.vue?vue&type=script&lang=js"
export * from "./EditStudentDataView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__